import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Icon } from '../icon';

const disabledStyle = {
  color: 'gray.100',
  name: 'square',
  family: 'fas',
};

export default function MultiCheckbox({
  value, onClick, modes, isDisabled, editable,
}) {
  return (
    <Flex
      opacity={editable ? 1 : 0.6}
      cursor={isDisabled ? 'default' : 'pointer'}>
      <Icon
        size="lg"
        onClick={() => {
          if (!isDisabled && editable) {
            onClick();
          }
        }}
        name="check-square"
        {...modes[value]}
        {...isDisabled && disabledStyle}
      />
    </Flex>
  );
}
